import { SelectProps } from "antd";
import { TipoIntervaloPeriodo } from "core/features/area-comum/typings";
import SelectBaseAntd from "../SelectBaseAntd";

export interface SelectIntervaloPeriodoProps<T = any> extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  onChange: (v: any) => void;
  plural?: boolean;
  filterValues?: (TipoIntervaloPeriodo | undefined)[];
}

function SelectIntervaloPeriodo({
  value,
  isInvalid,
  onChange,
  plural = false,
  filterValues = [
    TipoIntervaloPeriodo.Trimestre,
    TipoIntervaloPeriodo.Semestre,
  ],
  ...rest
}: SelectIntervaloPeriodoProps) {
  const options = Object.values(TipoIntervaloPeriodo)
    .map((value) => {
      const label = plural
        ? `${value.charAt(0).toLocaleUpperCase()}${value.slice(1)}s`
        : `${value.charAt(0).toLocaleUpperCase()}${value.slice(1)}`;

      return {
        value,
        label,
      };
    })
    .filter((option) => !filterValues?.includes(option.value));

  return (
    <>
      <SelectBaseAntd
        isInvalid={isInvalid}
        size="large"
        value={value}
        showSearch={false}
        allowClear={false}
        onChange={(ev) => {
          onChange(ev);
        }}
        options={options}
        {...rest}
      />
    </>
  );
}

export default SelectIntervaloPeriodo;
